// src/components/timeline/Timeline.jsx
import React from 'react';
import SectionWrapper from '../layout/SectionWrapper';

const timelineData = [
  {
    year: '2025',
    title: '???',
    description: 'Fusing AI with system design — building infra that learns, adapts, and compounds over time.'
  },
  {
    year: '2024',
    title: 'From Systems to Frameworks',
    description: 'Delivered real-time payments and self-serve reporting engines using Spring Boot and React. Learned to think in terms of reusable design and velocity.'
  },
  {
    year: '2024',
    title: 'Cutting Through the NLP Fog',
    description: 'Boosted chatbot precision with BERT + spaCy. Got obsessed with how language, structure, and feedback loops tie into intelligence.'
  },
];

export default function Timeline() {
  return (
    <SectionWrapper id="timeline">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white font-poppins text-center">Timeline</h2>
      <div className="relative border-l-2 border-cyan-700 pl-8 max-w-2xl mx-auto">
        {timelineData.map((item, idx) => (
          <div key={idx} className="mb-10 last:mb-0 relative">
            <div className="absolute -left-4 top-1 w-6 h-6 bg-cyan-700 rounded-full border-4 border-slate-900"></div>
            <div className="ml-2">
              <div className="text-cyan-400 font-bold text-lg">{item.year}</div>
              <div className="text-white font-semibold text-base mb-1">{item.title}</div>
              <div className="text-slate-300 text-sm">{item.description}</div>
            </div>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
}
